import tw from '@/lang/tw.json';
import en from '@/lang/en.json';

export default {
  ...tw,
  ...en,
};
